import PropTypes from 'prop-types';
import React from 'react';
import classnames from 'classnames';
import entityComposition from '../common/classes/entityComposition';
import UnsavedChangesNotification from './unsavedChangesNotification';
import UploadNotification from './uploadNotification';
import GeneralNotification from './generalNotification';

// must be defined outside of the component to avoid re-rendering loops
const defaultLeftButtonAction = () => {};
const defaultMiddleButtonAction = () => {};
const defaultRightButtonAction = () => {};
const Toaster = _ref => {
  let dismiss = _ref.notificationActions.dismiss,
    notificationList = _ref.list;
  return /*#__PURE__*/React.createElement("div", {
    className: classnames('tqc-toast-container', 't-toast-container')
  }, notificationList.map((toast, index) => {
    const id = toast.id,
      _toast$settings = toast.settings,
      showCloseButton = _toast$settings.showCloseButton,
      autoClose = _toast$settings.autoClose,
      _toast$content = toast.content,
      files = _toast$content.files,
      failedToUpload = _toast$content.failedToUpload,
      noAction = _toast$content.noAction,
      yesAction = _toast$content.yesAction,
      headerMessage = _toast$content.headerMessage,
      _toast$content$messag = _toast$content.messageType,
      messageType = _toast$content$messag === void 0 ? 'info' : _toast$content$messag,
      message = _toast$content.message,
      hint = _toast$content.hint,
      technicalDetail = _toast$content.technicalDetail,
      reference = _toast$content.reference,
      errorCode = _toast$content.errorCode,
      list = _toast$content.list,
      _toast$content$leftBu = _toast$content.leftButtonAction,
      _leftButtonAction = _toast$content$leftBu === void 0 ? defaultLeftButtonAction : _toast$content$leftBu,
      leftButtonLabel = _toast$content.leftButtonLabel,
      _toast$content$middle = _toast$content.middleButtonAction,
      _middleButtonAction = _toast$content$middle === void 0 ? defaultMiddleButtonAction : _toast$content$middle,
      middleButtonLabel = _toast$content.middleButtonLabel,
      _toast$content$rightB = _toast$content.rightButtonAction,
      _rightButtonAction = _toast$content$rightB === void 0 ? defaultRightButtonAction : _toast$content$rightB,
      rightButtonLabel = _toast$content.rightButtonLabel;

    // setup autoClose for components that don't have it disabled
    // could move this to the reducer layer and do a true update
    // (reset of timer) when a new one comes in with the same id
    if (autoClose && autoClose > 0) {
      setTimeout(() => dismiss(id), autoClose);
    }
    let toastComponent;
    switch (messageType) {
      case 'save':
        toastComponent = /*#__PURE__*/React.createElement(UnsavedChangesNotification, {
          key: id,
          noAction: noAction,
          yesAction: yesAction,
          close: () => dismiss(id)
        });
        break;
      case 'upload':
        toastComponent = /*#__PURE__*/React.createElement(UploadNotification, {
          key: id,
          handleClose: () => dismiss(id),
          files: files,
          failedToUpload: failedToUpload
        });
        break;
      default:
        toastComponent = /*#__PURE__*/React.createElement(GeneralNotification, {
          key: id,
          headerMessage: headerMessage,
          messageType: messageType,
          message: message,
          hint: hint,
          technicalDetail: technicalDetail,
          reference: reference,
          errorCode: errorCode,
          list: list,
          leftButtonLabel: leftButtonLabel,
          leftButtonAction: () => {
            _leftButtonAction();
            dismiss(id);
          },
          middleButtonLabel: middleButtonLabel,
          middleButtonAction: () => {
            _middleButtonAction();
            dismiss(id);
          },
          rightButtonLabel: rightButtonLabel,
          rightButtonAction: () => {
            _rightButtonAction();
            dismiss(id);
          }
        });
    }
    return /*#__PURE__*/React.createElement("div", {
      key: id,
      className: classnames('tqc-toast-notification', 't-toast-notification')
    }, /*#__PURE__*/React.createElement("div", {
      className: "tqc-toast-content"
    }, toastComponent), showCloseButton && /*#__PURE__*/React.createElement("button", {
      type: "submit",
      className: classnames('tqc-toast-close-button', "t-toast-close-button-".concat(index)),
      onClick: () => dismiss(id)
    }, "\u2716"));
  }));
};
Toaster.propTypes = {
  notificationActions: PropTypes.shape({
    dismiss: PropTypes.func
  }).isRequired,
  list: PropTypes.arrayOf(PropTypes.shape({})).isRequired
};
export { Toaster as TestToaster };
export default entityComposition(Toaster, [], {}, ['notification']);